import { render, staticRenderFns } from "./GetCollectedPayments.vue?vue&type=template&id=a10386f0&scoped=true&"
import script from "./GetCollectedPayments.vue?vue&type=script&lang=js&"
export * from "./GetCollectedPayments.vue?vue&type=script&lang=js&"
import style0 from "./GetCollectedPayments.vue?vue&type=style&index=0&id=a10386f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10386f0",
  null
  
)

export default component.exports